<template>
    <div class="slide-dot-outer">
        <div class="slide-dot" v-for="(w, key, idx) in this.namespace.PAGE"
             :class="'content-window-dot-index dot-' +idx"
             :key="key"
             @click="toPage(w.id)"></div>
    </div>
</template>

<script>
  import {toPage} from "../../js/common"
  import {scNamespace} from "../../js/scNamespace"

  export default {
    name: "slide-dot",
    data() {
      return {
        namespace: scNamespace,
      }
    },
    methods: {
      toPage: toPage
    }
  }
</script>

<style scoped>
    .slide-dot {
        width: 8px;
        height: 8px;
        margin: 0 auto;
        margin-bottom: 14px;
        border-radius: 50%;
        background-color: #2c3e50;
        opacity: 0.8;
        cursor: pointer;
        transition: all 0.2s;
    }

    .slide-dot.selected {
        width: 14px;
        height: 14px;
        opacity: 1;
    }

    .slide-dot-outer {
        height: 200px;
        width: 14px;
        z-index: 20000;
    }

    @media screen and (max-width: 960px) {
        .slide-dot-outer {
            display: none;
        }
    }
</style>